import apiClient from './axios.config';
import { API_ENDPOINTS } from '../../constants';

export const performanceAPI = {
    // ==================== APPRAISAL MANAGEMENT ====================
    
    // Get all appraisals with filtering and pagination
    getAllAppraisals: (params = {}) => apiClient.get(API_ENDPOINTS.APPRAISALS, { params }),
    
    // Get appraisal by ID
    getAppraisalById: (id) => apiClient.get(API_ENDPOINTS.APPRAISAL_BY_ID(id)),
    
    // Create new appraisal
    createAppraisal: (appraisalData) => apiClient.post(API_ENDPOINTS.APPRAISALS, appraisalData),
    
    // Update appraisal
    updateAppraisal: (id, appraisalData) => apiClient.put(API_ENDPOINTS.APPRAISAL_BY_ID(id), appraisalData),
    
    // Delete appraisal
    deleteAppraisal: (id) => apiClient.delete(API_ENDPOINTS.APPRAISAL_BY_ID(id)),
    
    // Get current user's appraisals
    getMyAppraisals: (params = {}) => apiClient.get(API_ENDPOINTS.APPRAISALS_MY, { params }),
    
    // Get appraisals pending review
    getAppraisalsPendingReview: (params = {}) => apiClient.get(API_ENDPOINTS.APPRAISALS_PENDING_REVIEW, { params }),
    
    // Submit appraisal for review
    submitAppraisalForReview: (id, reviewData) => apiClient.post(API_ENDPOINTS.APPRAISALS_SUBMIT(id), reviewData),
    
    // Get appraisal statistics
    getAppraisalStats: (params = {}) => apiClient.get(API_ENDPOINTS.APPRAISALS_STATS, { params }),
    
    // Export appraisals to Excel
    exportAppraisals: (params = {}) => apiClient.get(API_ENDPOINTS.APPRAISALS_EXPORT, { 
        params,
        responseType: 'blob'
    }),

    // ==================== OBJECTIVE MANAGEMENT ====================
    
    // Get all objectives
    getAllObjectives: (params = {}) => apiClient.get(API_ENDPOINTS.OBJECTIVES, { params }),
    
    // Get objective by ID
    getObjectiveById: (id) => apiClient.get(API_ENDPOINTS.OBJECTIVE_BY_ID(id)),
    
    // Create new objective
    createObjective: (objectiveData) => apiClient.post(API_ENDPOINTS.OBJECTIVES, objectiveData),
    
    // Update objective
    updateObjective: (id, objectiveData) => apiClient.put(API_ENDPOINTS.OBJECTIVE_BY_ID(id), objectiveData),
    
    // Delete objective
    deleteObjective: (id) => apiClient.delete(API_ENDPOINTS.OBJECTIVE_BY_ID(id)),
    
    // Get current user's objectives
    getMyObjectives: (params = {}) => apiClient.get(API_ENDPOINTS.OBJECTIVES_MY, { params }),
    
    // Get objectives pending approval
    getObjectivesPendingApproval: (params = {}) => apiClient.get(API_ENDPOINTS.OBJECTIVES_PENDING_APPROVAL, { params }),
    
    // Get objective statistics
    getObjectiveStats: (params = {}) => apiClient.get(API_ENDPOINTS.OBJECTIVES_STATS, { params }),
};